'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _onlinepbxTableInput = require('./onlinepbx-table-input');

var _onlinepbxTableInput2 = _interopRequireDefault(_onlinepbxTableInput);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BLOCK_TIME_REG = /\([0-2]{0,1}[0-9]:[0-5]{0,1}[0-9]-[0-2]{0,1}[0-9]:[0-5]{0,1}[0-9]\)/g;
var SYMBOL_INPUT_REG = /[():\-0-9]/g;
var ALL_DAY = '(00:00-23:59)';

var OnlinepbxTableInputTimeLogic = function (_React$PureComponent) {
  _inherits(OnlinepbxTableInputTimeLogic, _React$PureComponent);

  function OnlinepbxTableInputTimeLogic() {
    _classCallCheck(this, OnlinepbxTableInputTimeLogic);

    var _this = _possibleConstructorReturn(this, (OnlinepbxTableInputTimeLogic.__proto__ || Object.getPrototypeOf(OnlinepbxTableInputTimeLogic)).call(this));

    _this.state = {
      isFocus: false,
      changedValue: null
    };
    return _this;
  }

  _createClass(OnlinepbxTableInputTimeLogic, [{
    key: 'getValue',
    value: function () {
      function getValue() {
        var _state = this.state,
            isFocus = _state.isFocus,
            changedValue = _state.changedValue;
        var _props = this.props,
            defaultValue = _props.defaultValue,
            value = _props.value,
            onChange = _props.onChange;


        if (!isFocus && !value) {
          onChange(defaultValue || ALL_DAY);
        }

        var resultValue = changedValue === null ? value : changedValue;

        if (!isFocus && resultValue === ALL_DAY) {
          return 'Весь день';
        }
        return resultValue;
      }

      return getValue;
    }()
  }, {
    key: 'formattingTime',
    value: function () {
      function formattingTime(value) {
        var result = ((value || '').match(BLOCK_TIME_REG) || []).map(function (timeBlock) {
          var hoursFrom = Number(timeBlock.split('(')[1].split(':')[0]) || 0;
          var minutesFrom = Number(timeBlock.split('(')[1].split(':')[1].split('-')[0]) || 0;
          if (hoursFrom > 23) {
            return '';
          }

          var hoursTo = Number(timeBlock.split('(')[1].split('-')[1].split(':')[0]) || 0;
          var minutesTo = Number(timeBlock.split('(')[1].split('-')[1].split(':')[1].split(')')[0]) || 0;
          if (hoursTo > 23) {
            return '';
          }

          var resultTime = '(';
          if (hoursFrom < 10) {
            resultTime += '0';
          }
          resultTime += hoursFrom;

          resultTime += ':';

          if (minutesFrom < 10) {
            resultTime += '0';
          }
          resultTime += minutesFrom;

          resultTime += '-';

          if (hoursTo < 10) {
            resultTime += '0';
          }
          resultTime += hoursTo;

          resultTime += ':';

          if (minutesTo < 10) {
            resultTime += '0';
          }
          resultTime += minutesTo;

          resultTime += ')';

          return resultTime;
        }).join('');
        return result || ALL_DAY;
      }

      return formattingTime;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props2 = this.props,
            value = _props2.value,
            placeholder = _props2.placeholder,
            onChange = _props2.onChange,
            props = _objectWithoutProperties(_props2, ['value', 'placeholder', 'onChange']);

        return _react2['default'].createElement(_onlinepbxTableInput2['default'], _extends({}, props, {
          isControlValue: true,
          placeholder: placeholder || ALL_DAY,
          maxLength: '128',
          value: this.getValue(),
          onFocus: function () {
            function onFocus() {
              _this2.setState({ isFocus: true, changedValue: null });
            }

            return onFocus;
          }(),
          onBlur: function () {
            function onBlur(evt) {
              _this2.setState({ isFocus: false, changedValue: null });
              typeof onChange === 'function' && onChange(_this2.formattingTime(evt.target.value));
            }

            return onBlur;
          }(),
          onChange: function () {
            function onChange(evt) {
              if (evt.target.value !== value) {
                _this2.setState({ changedValue: (evt.target.value.match(SYMBOL_INPUT_REG) || []).join('') });
              }
            }

            return onChange;
          }()
        }));
      }

      return render;
    }()
  }]);

  return OnlinepbxTableInputTimeLogic;
}(_react2['default'].PureComponent);

exports['default'] = OnlinepbxTableInputTimeLogic;